
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
    MdDashboard,
    MdDescription,
    MdAnalytics,
    // MdShoppingCart,
    MdInventory,
    MdSettings,
    MdClose,
    MdBusinessCenter,
    MdStore,
    MdBadge,
    MdNotifications,
    MdSecurity,
    MdCompareArrows,
    MdPeople,
    MdFlag,
    MdPayment,
    MdRequestQuote,
    MdChat,
    MdCategory,
    MdSubdirectoryArrowRight,
    MdStraighten,
    MdList,
    MdExpandMore,
    MdExpandLess,
    MdInput,
    MdHistory
} from 'react-icons/md';
import { useUser } from '../context/UserContext';
import Loader from './common/Loader';
import './Sidebar.css';

const Sidebar = ({ isOpen, closeSidebar }) => {
    const { menus, permissions, role, userProfile, loading, hasPermission } = useUser();
    const [expandedGroups, setExpandedGroups] = React.useState({
        'Project Management': false,
        'Product Management': false,
        'Reports': false
    });

    const toggleGroup = (groupName) => {
        setExpandedGroups(prev => ({
            ...prev,
            [groupName]: !prev[groupName]
        }));
    };

    const menuStructure = [
        { path: '/', name: 'Dashboard', icon: <MdDashboard />, constant: 'DASHBOARD' },
        { path: '/customers', name: 'Customers', icon: <MdPeople />, constant: 'CUSTOMERS' },
        { path: '/vendors', name: 'Vendors', icon: <MdStore />, constant: 'VENDORS' },
        {
            groupName: 'Project Management',
            icon: <MdBusinessCenter />,
            children: [
                { path: '/projects', name: 'Projects', constant: 'PROJECTS' },
                { path: '/project-categories', name: 'Categories', constant: 'PROJECT_CATEGORIES' },
                { path: '/project-sub-categories', name: 'Sub-Categories', constant: 'PROJECT_SUB_CATEGORIES' },
                { path: '/project-sub-category-details', name: '(BHK) Sub-Category Details', constant: 'PROJECT_SUB_CATEGORY_DETAILS' },
            ]
        },
        {
            groupName: 'Product Management',
            icon: <MdInventory />, // Or another icon
            children: [
                { path: '/products', name: 'Products', constant: 'PRODUCTS' },
                { path: '/product-categories', name: 'Categories', constant: 'PRODUCT_CATEGORIES' },
                { path: '/unit-master', name: 'Unit', constant: 'UNIT' },
            ]
        },
        { path: '/generate-requests', name: 'Generate Requests', icon: <MdDescription />, constant: 'PURCHASE_ORDERS' },
        { path: '/view-quotations', name: 'View Quotations', icon: <MdRequestQuote />, constant: 'VIEW_QUOTATIONS' },
        { path: '/compare-po', name: 'Compare PO', icon: <MdCompareArrows />, constant: 'COMPARE_PO' },
        { path: '/po-management', name: 'PO Management', icon: <MdInventory />, constant: 'PO_MANAGEMENT' },
        { path: '/inward-management', name: 'Inward Management', icon: <MdInput />, constant: 'INWARD_MANAGEMENT' },
        { path: '/payment-management', name: 'Payment Management', icon: <MdPayment />, constant: 'PAYMENT_MANAGEMENT' },
        {
            groupName: 'Reports',
            icon: <MdAnalytics />,
            children: [

                { path: '/reports/vendor-payment-overdue', name: 'Vendor Payment OverDue Report', constant: 'VENDOR_PAYMENT_OVERDUE_REPORT' },
                { path: '/reports/project-summary', name: 'Project Summary', constant: 'PROJECT_SUMMARY' },
                { path: '/reports/project-product-summary', name: 'Product Summary', constant: 'PRODUCT_SUMMARY' },
                { path: '/reports/vendor-summary', name: 'Vendor Summary', constant: 'VENDOR_SUMMARY' },
                { path: '/reports/log', name: 'Report Log', constant: 'REPORT_LOG' },


            ]
        },
        { path: '/history', name: 'History Log', icon: <MdHistory />, constant: 'HISTORY_LOG' },
        { path: '/employees', name: 'Associates ', icon: <MdBadge />, constant: 'EMPLOYEES' },
        // { path: '/whatsapp-auth', name: 'Whatsapp Auth', icon: <MdChat />, constant: 'WHATSAPP_AUTH' },
        { path: '/permission-rights', name: 'Permissions', icon: <MdSecurity />, constant: 'PERMISSIONS' },
        { path: '/settings', name: 'Settings', icon: <MdSettings />, constant: 'SETTINGS' },
        { path: '/priority-management', name: 'Priority', icon: <MdFlag />, constant: 'PRIORITIES' },

    ];

    const renderMenu = () => {
        return menuStructure.map((item, index) => {
            // Render Group
            if (item.groupName) {
                // Check if any child is visible
                const visibleChildren = item.children.filter(child => hasPermission(child.constant));
                if (visibleChildren.length === 0) return null;

                const isExpanded = expandedGroups[item.groupName];
                return (
                    <div key={index} className={`menu-group ${isExpanded ? 'expanded' : ''}`}>
                        <div
                            className="menu-group-header"
                            onClick={() => toggleGroup(item.groupName)}
                        >
                            <div className="group-label">
                                <span className="menu-icon">{item.icon}</span>
                                <span>{item.groupName}</span>
                            </div>
                            <span className="group-toggle-icon">
                                {isExpanded ? <MdExpandLess /> : <MdExpandMore />}
                            </span>
                        </div>
                        <div className="submenu">
                            {visibleChildren.map(child => (
                                <NavLink
                                    key={child.path}
                                    to={child.path}
                                    className={({ isActive }) => `menu-item submenu-item ${isActive ? 'active' : ''}`}
                                    onClick={closeSidebar}
                                >
                                    <span>{child.name}</span>
                                </NavLink>
                            ))}
                        </div>
                    </div>
                );
            }

            // Render Single Item
            if (!hasPermission(item.constant)) return null;

            return (
                <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
                    onClick={closeSidebar}
                >
                    <span className="menu-icon">{item.icon}</span>
                    <span>{item.name}</span>
                </NavLink>
            );
        });
    };

    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-logo">
                <span>Inceppt</span>
                <button className="sidebar-close-btn" onClick={closeSidebar}>
                    <MdClose />
                </button>
            </div>

            <nav className="sidebar-menu">
                {loading ? (
                    <Loader size="small" text="Loading menus..." />
                ) : (
                    renderMenu()
                )}
            </nav>
        </div>
    );
};

export default Sidebar;
